/* V_NUF_LP_06 | Reorder the Main Lander Image Gallery Around Proof (Lymphaire Inspo)
 * Var A (body.c-nufLp06VarA): puts the proof-first images into the existing gallery, position
 * by position, from the Liquid-rendered .c-nuf-lp-06-config. The slider, slide elements,
 * thumbnails, swipe and thumbnail behaviour are the theme's own and stay untouched; only each
 * slot's image and alt text change, including Slick's cloned copies (the thumbnail strip shows
 * them when it wraps round, so a missed clone would bring back a removed Control image).
 * Position 1 keeps Control's hero file (the seal is a CSS overlay), so LCP does not change.
 * Control only runs trackViews() (measurement); nothing visual changes for it.
 */
(function () {
  var VAR_A = 'c-nufLp06VarA';
  var MAIN_SLIDES = '.slider-main .slide-item';
  var THUMBS = '.slider-nav .nav-item';
  var applied = false;
  var observer;

  function readConfig() {
    var slots = {};
    document.querySelectorAll('.c-nuf-lp-06-config [data-c-position]').forEach(function (el) {
      slots[el.getAttribute('data-c-position')] = {
        src: el.getAttribute('data-c-src'),
        thumb: el.getAttribute('data-c-thumb'),
        alt: el.getAttribute('data-c-alt')
      };
    });
    return slots;
  }

  /* Every copy of each slide with its gallery position (1-8). Slick clones slides for its
   * infinite loop with an empty id, so clones are matched by data-slick-index instead:
   * -1 is a copy of the last slide, count is a copy of the first, and so on. Before Slick
   * starts there are no clones and the originals are simply in order. */
  function slidesByPosition(selector) {
    var originals = document.querySelectorAll(selector + ':not(.slick-cloned)');
    var count = originals.length;
    var all = document.querySelectorAll(selector);
    return Array.prototype.map.call(all, function (el, order) {
      var index = el.hasAttribute('data-slick-index') ? parseInt(el.getAttribute('data-slick-index'), 10) : order;
      return { el: el, position: (((index % count) + count) % count) + 1 };
    });
  }

  function pathOf(url) {
    try { return new URL(url, window.location.href).pathname; } catch (e) { return url; }
  }

  function setImage(img, src, alt) {
    if (alt) img.alt = alt;
    var current = img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (pathOf(current) === pathOf(src)) return;
    // Both attributes, so the theme's data-src lazy loader resolves to the new file too
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', src);
    img.setAttribute('loading', 'lazy');
    img.setAttribute('src', src);
  }

  function swapSlots(selector, slots, key) {
    slidesByPosition(selector).forEach(function (item) {
      var slot = slots[String(item.position)];
      if (!slot || !slot[key]) return;
      item.el.querySelectorAll('img').forEach(function (img) {
        setImage(img, slot[key], slot.alt);
      });
    });
  }

  function apply() {
    if (applied || !document.body.classList.contains(VAR_A)) return;
    applied = true;
    if (observer) observer.disconnect();
    var slots = readConfig();
    swapSlots(MAIN_SLIDES, slots, 'src');
    swapSlots(THUMBS, slots, 'thumb');
  }

  /* Measurement, both groups: show the view marker of the image the slider has settled on.
   * afterChange fires once the slide animation ends, so images the slider only passes through
   * (2 when jumping from 1 to 3 with a thumbnail) are never marked. Image 1 is marked on load. */
  function trackViews() {
    var markers = document.querySelectorAll('.c-nuf-lp-06-view');
    if (!markers.length || !window.jQuery) return;
    var $main = window.jQuery('.slider-main');
    function show(index) {
      markers.forEach(function (marker) {
        marker.classList.toggle('is-current', marker.getAttribute('data-c-position') === String(index + 1));
      });
    }
    $main.on('init', function (evt, slick) { show(slick.currentSlide || 0); });
    $main.on('afterChange', function (evt, slick, current) { show(current); });
    if ($main.hasClass('slick-initialized')) show($main.slick('slickCurrentSlide'));
  }

  function init() {
    if (!document.querySelector('.c-nuf-lp-06-config')) return;
    trackViews();
    apply();
    if (applied) return;
    // The group arrives after Intelligems is ready; MutationObserver runs before the next
    // paint, so the thumbnail strip (hidden until c-igReady) never shows Control's images
    observer = new MutationObserver(apply);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
